import { render, staticRenderFns } from "./DetailOnLeave.vue?vue&type=template&id=95acac7e&scoped=true&lang=html"
import script from "./DetailOnLeave.vue?vue&type=script&lang=js"
export * from "./DetailOnLeave.vue?vue&type=script&lang=js"
import style0 from "./DetailOnLeave.vue?vue&type=style&index=0&id=95acac7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95acac7e",
  null
  
)

export default component.exports